import Loader from "@/components/Loader";
import Homepage from "@/modules/Home";
import Dashboard from "@/modules/Dashboard";
import Watchlist from "@/modules/Watchlist";
import PaperTrade from "@/modules/PaperTrade";

import Loadable from "react-loadable";

export const login: ModuleRoute = {
  title: "Login",
  component: Loadable({
    loader: () => import("@/modules/Auth/Login"),
    loading: Loader
  }),
  path: "/login",
  exact: true
};

export const register: ModuleRoute = {
  title: "Register",
  component: Loadable({
    loader: () => import("@/modules/Auth/Register"),
    loading: Loader
  }),
  path: "/register",
  exact: true
};

export const home: ModuleRoute = {
  title: "Home",
  component: Homepage,
  path: "/",
  exact: true
};

export const watchlist: ModuleRoute = {
  title: "Watchlist",
  component: Watchlist,
  path: "/watchlist",
  exact: true
};

export const dashboard: ModuleRoute = {
  title: "Dashboard",
  component: Dashboard,
  path: "/dashboard",
  exact: true
};

export const dectAnom: ModuleRoute = {
  title: "Anomaly",
  component: Loadable({
    loader: () => import("@/modules/Detection/Anomaly"),
    loading: Loader
  }),
  path: "/detection/anomaly-detection",
  exact: true
};

export const dectOpp: ModuleRoute = {
  title: "Screener",
  component: Loadable({
    loader: () => import("@/modules/Detection/Opportunistic"),
    loading: Loader
  }),
  path: "/detection/opportunistic-detection",
  exact: true
};
